export default __webpack_public_path__ + "static/media/5_3.384f6e39.png";